<template>
  <div class="changepassword">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Change Password</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->

              <form @submit.prevent="updatePassword" class="was-validated">
                <div class="form-group">
                  <label>Old password</label>
                  <input
                    v-model="passwordArr.member_password_old"
                    type="password"
                    class="form-control"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>New password</label>
                  <input
                    v-model="passwordArr.member_password_new"
                    type="password"
                    class="form-control"
                    minlength="6"
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Confirm password</label>
                  <input
                    v-model="passwordArr.member_password_new_repeat"
                    type="password"
                    minlength="6"
                    class="form-control"
                    required
                  />
                </div>
                <div class="submit-section">
                  <button :disabled="isLoading" class="btn btn-primary submit-btn">Update Password</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion
  },
  data() {
    return {
      isLoading: false,
      passwordArr: {
        member_password_old: "",
        member_password_new: "",
        member_password_new_repeat: ""
      }
    };
  },
  methods: {
    updatePassword() {
      this.isLoading = true;

      this.$store
        .dispatch("member/updatePassword", this.passwordArr)
        .then(response => {
          this.isLoading = false;

          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "changepassword"
};
</script>


// WEBPACK FOOTER //
// src/components/changepassword.vue